var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateRangeOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_435",
    "data-name": "Rectangle 435",
    width: 18,
    height: 20,
    fill: "#333"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#334856",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2104",
    "data-name": "Groupe 2104",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2103",
    "data-name": "Groupe 2103",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_774",
    "data-name": "Trac\\xE9 774",
    d: "M4,9H6v2H4ZM18,4V18a2.006,2.006,0,0,1-2,2H2a2,2,0,0,1-2-2L.01,4A1.991,1.991,0,0,1,2,2H3V0H5V2h8V0h2V2h1a2.006,2.006,0,0,1,2,2M2,6H16V4H2ZM16,8H2V18H16Zm-4,3h2V9H12ZM8,11h2V9H8Z",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateRangeOutlined);
export default __webpack_public_path__ + "static/media/DateRangeOutlined.2ebd2e6b8f6fc0b37e8504b22f6eaf17.svg";
export { ForwardRef as ReactComponent };